import styled from 'styled-components';

import SearchTreePopover from '@/components/SearchTreePopover';
import { CSS_PREFIX } from '@/constants/styles';
import { NeutralColors } from '@/theme';

export const SeasonPopover = styled(SearchTreePopover)`
  height: auto;
  max-height: 360px;
  overflow-y: auto;

  .${CSS_PREFIX}-tree-treenode.season-section-divider {
    width: 100%;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid ${NeutralColors[20]};
  }

  .${CSS_PREFIX}-tree-switcher {
    display: none;
  }

  .${CSS_PREFIX}-tree-indent {
    display: none;
  }

  .${CSS_PREFIX}-tree-node-content-wrapper {
    flex: 1;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid ${NeutralColors[20]};

  .${CSS_PREFIX}-btn {
    border-radius: 999px;
  }
`;

export const NoResults = styled.div`
  color: ${NeutralColors[60]};
  text-align: center;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
`;
